export default {
    requirements: {
        low: {
            id: 'low',
            name: 'Low',
            totalFootage: 64,
            staffing: 0.05,
            staffingCode: "da",
            equipment: ["Tabletop Scanner"],
            software: [],
            otherItems: []
        },

        medium: {
            id: 'medium',
            name: 'Medium',
            totalFootage: 64,
            staffing:0.1,
            staffingCode: "da",
            equipment: ["Tabletop Scanner"],
            software: [],
            otherItems: []
        },

        high: {
            id: 'high',
            name: 'High',
            totalFootage: 64,
            staffing: 0.125,
            staffingCode: "da",
            equipment: ["Tabletop Scanner"],
            software: [],
            otherItems: []
        },
    },

    ratingDetails: [
        {
            id: 'level',
            type: 'enum',
            required: false,
            component: 'PulloutQuestionMultiSwitchList',
            default: 0,
            label: "Level of Need:",
            options: [
                {
                    id: "none",
                    label: "None",
                    value: 0
                },

                {
                    id: "low",
                    label: "Low",
                    description: "up to 190 docs per day",
                    value: 1
                },
                {
                    id: "medium",
                    label: "Medium",
                    description: "up to 430 docs per day",
                    value: 2
                },
                {
                    id: "high",
                    label: "High",
                    description: "up to 550 docs per day",
                    value: 3
                }
            ]
        }

    ]
}
